/**
 * Override slice for the MasterView store.
 *
 * Manages company context, field overrides, global values,
 * and the "show global values" toggle for GLOBAL master types.
 *
 * @internal
 * @module store/slices/overrideSlice
 */
import type { StateCreator } from 'zustand';
import type { MasterPatternViewEntity } from '../../types/service.types';
import type { MasterPatternViewDefinition } from '../../types/definition.types';
import type { MasterViewState, OverrideState } from '../types';

export const createOverrideSlice = <T extends MasterPatternViewEntity>(
  definition: MasterPatternViewDefinition,
): StateCreator<MasterViewState<T>, [], [], OverrideState> =>
  (set) => ({
    activeCompanyContext: (
      definition.type === 'GLOBAL' ||
      ((definition.type === 'CONFIG_TABLE' || definition.type === 'CUSTOM') && definition.companyBehavior === 'GLOBAL')
    ) ? 'global' : undefined,
    overrides: {},
    globalValues: {},
    isShowGlobalValuesEnabled: false,
    revertedFields: [],

    setActiveCompanyContext: (context: string | undefined) =>
      set({ activeCompanyContext: context }),

    setOverrides: (overrides: Record<string, unknown>) =>
      set({ overrides }),

    setGlobalValues: (values: Record<string, unknown>) =>
      set({ globalValues: values }),

    toggleShowGlobalValues: () =>
      set((state) => ({ isShowGlobalValuesEnabled: !state.isShowGlobalValuesEnabled })),

    setRevertedFields: (fields: string[]) =>
      set({ revertedFields: fields }),
  });
